/**
 * Proveedores scrapeados con escaparate propio (/coliving/:slug)
 * en lugar de redirect a /encuentratucoliving/:slug
 */
export const PROVIDER_SHOWCASE_SLUGS = ['spacest'];

/** Límite al cargar inventario completo (Spacest ~4k activos) */
export const PROVIDER_SHOWCASE_FETCH_LIMIT = 5000;

export function isProviderShowcaseSlug(slug) {
  return PROVIDER_SHOWCASE_SLUGS.includes(String(slug || '').toLowerCase());
}
